import { createActions, handleActions } from 'redux-actions'

// helpers
import { loadingError, startLoading, startSubmitting } from './_helpers'

export const CREATE_FORM = 'sefForms/CREATE_FORM'
export const CREATE_FORM_FAILURE = 'sefForms/CREATE_FORM_FAILURE'
export const CREATE_FORM_SUCCESS = 'sefForms/CREATE_FORM_SUCCESS'

export const DELETE_FORM = 'sefForms/DELETE_FORM'
export const DELETE_FORM_FAILURE = 'sefForms/DELETE_FORM_FAILURE'
export const DELETE_FORM_SUCCESS = 'sefForms/DELETE_FORM_SUCCESS'

export const FETCH_FORM = 'sefForms/FETCH_FORM'
export const FETCH_FORM_FAILURE = 'sefForms/FETCH_FORM_FAILURE'
export const FETCH_FORM_SUCCESS = 'sefForms/FETCH_FORM_SUCCESS'

export const FETCH_FORM_ANSWERS = 'sefForms/FETCH_FORM_ANSWERS'
export const FETCH_FORM_ANSWERS_FAILURE = 'sefForms/FETCH_FORM_ANSWERS_FAILURE'
export const FETCH_FORM_ANSWERS_SUCCESS = 'sefForms/FETCH_FORM_ANSWERS_SUCCESS'

export const FETCH_FORMS = 'sefForms/FETCH_FORMS'
export const FETCH_FORMS_FAILURE = 'sefForms/FETCH_FORMS_FAILURE'
export const FETCH_FORMS_SUCCESS = 'sefForms/FETCH_FORMS_SUCCESS'

export const UPDATE_FORM = 'sefForms/UPDATE_FORM'
export const UPDATE_FORM_FAILURE = 'sefForms/UPDATE_FORM_FAILURE'
export const UPDATE_FORM_SUCCESS = 'sefForms/UPDATE_FORM_SUCCESS'

export const {
  sefForms: {
    createForm,
    createFormSuccess,
    createFormFailure,
    deleteForm,
    deleteFormSuccess,
    deleteFormFailure,
    fetchForm,
    fetchFormSuccess,
    fetchFormFailure,
    fetchFormAnswers,
    fetchFormAnswersSuccess,
    fetchFormAnswersFailure,
    fetchForms,
    fetchFormsSuccess,
    fetchFormsFailure,
    updateForm,
    updateFormSuccess,
    updateFormFailure
  }
} = createActions({
  [CREATE_FORM]: undefined,
  [CREATE_FORM_FAILURE]: undefined,
  [CREATE_FORM_SUCCESS]: undefined,

  [DELETE_FORM]: undefined,
  [DELETE_FORM_FAILURE]: undefined,
  [DELETE_FORM_SUCCESS]: undefined,

  [FETCH_FORM]: undefined,
  [FETCH_FORM_FAILURE]: undefined,
  [FETCH_FORM_SUCCESS]: undefined,

  [FETCH_FORM_ANSWERS]: undefined,
  [FETCH_FORM_ANSWERS_FAILURE]: undefined,
  [FETCH_FORM_ANSWERS_SUCCESS]: undefined,

  [FETCH_FORMS]: undefined,
  [FETCH_FORMS_FAILURE]: undefined,
  [FETCH_FORMS_SUCCESS]: undefined,

  [UPDATE_FORM]: undefined,
  [UPDATE_FORM_FAILURE]: undefined,
  [UPDATE_FORM_SUCCESS]: undefined
})

const initialState = {
  errorMessage: null,
  hasError: false,
  isLoading: false,
  isSubmitting: false,
  isSuccess: null,
  paginatedFormsData: {
    forms: [],
    formsCount: 0,
    formsPageCount: 0
  },
  singleFormData: {}
}

export default handleActions(
  {
    [CREATE_FORM]: startSubmitting,
    [CREATE_FORM_FAILURE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload.message || 'An unknown error occurred',
      isLoading: false,
      isSuccess: false
    }),
    [CREATE_FORM_SUCCESS]: state => ({
      ...state,
      isLoading: false,
      isSubmitting: false,
      isSuccess: true,
      hasError: false
    }),

    [DELETE_FORM]: state => ({ ...state, isLoading: true }),
    [DELETE_FORM_SUCCESS]: state => {
      return { ...state, isLoading: false, isSubmitting: false }
    },
    [DELETE_FORM_FAILURE]: state => ({ ...state, isLoading: false }),

    [FETCH_FORM]: startLoading,
    [FETCH_FORM_FAILURE]: loadingError,
    [FETCH_FORM_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleFormData: payload,
      isLoading: false,
      isError: false
    }),

    [FETCH_FORM_ANSWERS]: startLoading,
    [FETCH_FORM_ANSWERS_FAILURE]: loadingError,
    [FETCH_FORM_ANSWERS_SUCCESS]: (state, { payload }) => ({
      ...state,
      singleFormData: payload,
      isLoading: false,
      isError: false
    }),

    [FETCH_FORMS]: startLoading,
    [FETCH_FORMS_FAILURE]: loadingError,
    [FETCH_FORMS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        errorMessage: null,
        hasSubmitted: false,
        isError: false,
        isLoading: false,
        isSuccess: true
      }

      newState.paginatedFormsData.formsPageCount = payload.pageCount || 0
      newState.paginatedFormsData.formsCount = payload.formsCount || 0
      newState.paginatedFormsData.forms = payload.forms || []

      return newState
    },

    [UPDATE_FORM]: startSubmitting,
    [UPDATE_FORM_FAILURE]: loadingError,
    [UPDATE_FORM_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        isSuccess: true
      }
    }
  },
  initialState
)
